import Vue from 'vue'

import { $themeConfig } from '@themeConfig'

const SHIFT_API_URL = `${$themeConfig.app.backUrl}/shifts`
const DIVISIONS_API_URL = `${$themeConfig.app.backUrlDivisions}/divisions`

export function openShift(payload) {
    return Vue.axios.post(`${SHIFT_API_URL}/open`, payload)
}

export function closeShift(shiftId, payload) {
    return Vue.axios.post(`${SHIFT_API_URL}/${shiftId}/close`, payload)
}

export function getCurrentShift(divisionId, cashDeskId) {
    return Vue.axios.get(`${SHIFT_API_URL}/current?division_id=${divisionId}&cash_desk_id=${cashDeskId}`)
}

export function fetchShifts(divisionId, offset, limit) {
    return Vue.axios.get(`${SHIFT_API_URL}?division_id=${divisionId}&offset=${offset}&limit=${limit}`)
}

export function getDivisionById(divisionId) {
    return Vue.axios.get(`${DIVISIONS_API_URL}/${divisionId}`)
}

